import { useEffect } from 'react'
const PICKER_MENU_SELECTOR = '.rs-picker-popup, .rs-picker-menu'

const handleScroll = (e: Event): void => {
  const menu = document.querySelector(PICKER_MENU_SELECTOR)
  if (!menu) return 

  const target = e.target as Node | null
  if (target && menu.contains(target)) return

  document.body.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }))
}

let consumerCount = 0

export const useClosePickersOnScroll = (): void => {
  useEffect(() => {
    if (consumerCount === 0) {
      document.addEventListener('scroll', handleScroll, true)
    }
    consumerCount += 1
    return () => {
      consumerCount -= 1
      if (consumerCount === 0) {
        document.removeEventListener('scroll', handleScroll, true)
      }
    }
  }, [])
}

export default useClosePickersOnScroll
